import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React from 'react'

/**
 * プログレストラッカー4
 */
const ErrorIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="157"
      height="9"
      viewBox="0 0 157 9"
    >
      <rect
        width="150"
        height="1"
        rx="0.5"
        transform="translate(0 4)"
        fill={CLIENT_SETTINGS.colors.main}
      />
      <circle
        cx="4.5"
        cy="4.5"
        r="4.5"
        fill={CLIENT_SETTINGS.colors.borderColor}
      />
      <circle
        cx="4.5"
        cy="4.5"
        r="4.5"
        transform="translate(37)"
        fill={CLIENT_SETTINGS.colors.borderColor}
      />
      <circle
        cx="4.5"
        cy="4.5"
        r="4.5"
        transform="translate(74)"
        fill={CLIENT_SETTINGS.colors.borderColor}
      />
      <circle
        cx="4.5"
        cy="4.5"
        r="4.5"
        transform="translate(148)"
        fill={CLIENT_SETTINGS.colors.main}
      />
      <rect
        width="109"
        height="1"
        rx="0.5"
        transform="translate(4 4)"
        fill={CLIENT_SETTINGS.colors.borderColor}
      />
      <g
        transform="translate(111)"
        fill={CLIENT_SETTINGS.colors.textForMainBackground}
        stroke={CLIENT_SETTINGS.colors.main}
        strokeWidth="3"
      >
        <circle cx="4.5" cy="4.5" r="4.5" stroke="none" />
        <circle cx="4.5" cy="4.5" r="3" fill="none" />
      </g>
    </svg>
  )
}

export default ErrorIcon
